import { Response } from '@candu-ai/first-mate/api';

export const COMPLETIONS_API = '/api/first-mate/completion';

export type CompletionsRequest = {
  history: string[];
  content: string;
};

interface CompletionChoice {
  message: {
    content: string;
  };
}

export type CompletionsResponse = Response<{
  choices: CompletionChoice[];
}>;
